import Vue from 'vue';
import Router from 'vue-router';

import store from './store';
import LandingPage from './views/LandingPage.vue';
import PageNotFound from '@/views/PageNotFound.vue';


Vue.use(Router);


function requireAuth(to: any, from: any, next: any) {
  if (store.getters.getAuth.login) {
    next();
  } else {
    if (from.path === '/login') {
      // to make sure navigation does not dissapeart !important
      store.commit('MUTATE_SHOW_NAVIGATION', true);
    }
    next('/login');
  }
}

function notRequireAuth(to: any, from: any, next: any) {
  if (store.getters.getAuth.login) {
    if (from.path === '/home') {
      // to make sure navigation does not dissapeart !important
      store.commit('MUTATE_SHOW_NAVIGATION', true);
    }
    next('/home');
  } else {
    next();
  }
}

// to make sure it's backward compatible we redirect old url to new version
function getVersion(v: any) {
  switch (v) {
    case 'public':
      return 1;
    case 'papyrus':
      return 2;
    case 'horizon':
      return 3;
    default:
      return v;
  }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      component: LandingPage,
      beforeEnter: notRequireAuth,
    },
    {
      path: '/:v/:merchant/:uuid/:address',
      name: 'public',
      // redirect: '/?v=:v&m=:merchant&u=:uuid&a=:address',
      redirect: ((to: any) => {
        // console.log('to', to);

        const query = {
          v: getVersion(to.params.v),
          m: to.params.merchant,
          u: to.params.uuid,
          a: to.params.address,
        };
        return {name: 'certificate', query};
      }),
      component: LandingPage,
      beforeEnter: notRequireAuth,
    },
    {
      path: '/m/:forward',
      name: 'forward',
      component: LandingPage,
      beforeEnter: notRequireAuth,
    },

    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    //   beforeEnter: notRequireAuth,
    // },
    // {
    //   path: '/reset',
    //   name: 'reset',
    //   component: () => import(/* webpackChunkName: "reset" */ '@/views/ResetPassword.vue'),
    //   beforeEnter: notRequireAuth,
    // },
    // {
    //   path: '/activity',
    //   name: 'activity',
    //   component: () => import(/* webpackChunkName: "activity" */ '@/views/ActivityPage.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/asset',
    //   name: 'asset',
    //   component: () => import(/* webpackChunkName: "asset" */ '@/views/AssetPage.vue'),
    //   beforeEnter: requireAuth,
    // },
    {
      path: '/certificate',
      name: 'certificate',
      component: () => import(/* webpackChunkName: "certificate" */ '@/views/CertificatePage.vue'),
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: () => import(/* webpackChunkName: "home" */ '@/views/HomePage.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/email-confirmation',
    //   name: 'email-confirmation',
    //   component: () => import(/* webpackChunkName: "emailConfirmation" */ '@/views/EmailConfirmation.vue'),
    //   beforeEnter: notRequireAuth,
    // },
    // {
    //   path: '/forgot-password',
    //   name: 'forgot-password',
    //   component: () => import(/* webpackChunkName: "forgotPassword" */ '@/views/ForgotPassword.vue'),
    //   beforeEnter: notRequireAuth,
    // },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
    //   beforeEnter: notRequireAuth,
    // },
    {
      path: '/report',
      name: 'report',
      component: () => import(/* webpackChunkName: "report" */ '@/views/Report.vue'),
    },
    {
      path: '/reported',
      name: 'reported',
      component: () => import(/* webpackChunkName: "report-success" */ '@/views/Reported.vue'),
    },
    {
      path: '/secret',
      name: 'secret',
      component: () => import(/* webpackChunkName: "secret" */ '@/views/Secret.vue'),
    },
    {
      path: '/fake',
      name: 'fake',
      component: () => import(/* webpackChunkName: "secret" */ '@/views/FakeProductPage.vue'),
    },
    {
      path: '/page-not-found',
      name: 'page-not-found',
      component: PageNotFound,
    },
    { path: '*',
      redirect: ((to: any) => {
        return {name: 'page-not-found'};
      }),
    },
  ],
});

router.beforeEach((to: any, from: any, next: any) => {
  if (to.name === 'login' || to.name === 'register'
      || to.name === 'forgot-password' || to.name === 'email-confirmation'
      || to.name === 'report' || to.name === 'reported'
      || to.name === 'reset') {
    // hide navigation
    store.commit('MUTATE_SHOW_NAVIGATION', false);
  } else {
    // show navigation
    store.commit('MUTATE_SHOW_NAVIGATION', true);
  }
  next();
});

export default router;

